import React from 'react';
import { ProposalEntity } from 'v2/models';
import styles from './assignToMeAlert.module.scss';
import classnames from 'classnames';

interface AssignToMeAlertProps {
  proposal: ProposalEntity;
  isDetailsFormat?: boolean;
}

const AssignToMeAlert = ({
  proposal,
  isDetailsFormat = false,
}: AssignToMeAlertProps) => {
  if (isDetailsFormat) {
    return (
      <div className={classnames(styles.info, 'mb-4')}>
        This request has been assigned to&nbsp;
        {proposal.assigned_to?.first_name} {proposal.assigned_to?.last_name}
        .&nbsp;
        <strong>Do you want to respond anyway?</strong>
      </div>
    );
  }

  return (
    <div className="bg-light py-3 px-2">
      <p className={classnames('text-primary-dark m-0 pl-2', styles.alertText)}>
        Assigned to&nbsp;
        {proposal.assigned_to?.first_name} {proposal.assigned_to?.last_name}
      </p>
    </div>
  );
};

export default AssignToMeAlert;
